
import React, { PureComponent, Fragment } from "react";
import styles from "./ProgressBar.scss";
import { Interpolate } from "react-i18next";
import { TooltipBody, DivTooltip, Currency } from "@wg/wows-react-uikit";
import { COMPETITION_METRIC } from "../../UIKit/UIKit";
import { t, x } from "../../../helpers/localization";
import { thousands } from "../../../helpers/formatting";

import { CompetitionMetric } from "../../../Reducers/ReducerClanWars";

export type IBreakPoint = {
  reward: {
    title: string;
    type: string;
    description: string;
    imageUrl: string | null;
    amount: number;
  };
  value: number;
};

export type ProgressBar_Props = {
  title: string;
  target: any;
  subTitle?: string;
  mPoints: string;
  myValue?: number;
  myValueMax?: number;
  totalValue: number;
  maxValue: number;
  breakpoints: Array<IBreakPoint>;
  competitionMetric: CompetitionMetric;
  hideTitle?: boolean;
};
export type ProgressBar_State = {};

class ProgressBar extends PureComponent<ProgressBar_Props, ProgressBar_State> {


  getProgressPercent = (value: number, total: number) => {
    const p = value / total * 100;
    return p > 100 ? 100 : p;
  };

  getMetric = () => {
    switch (this.props.competitionMetric) {
      case COMPETITION_METRIC.EXP:
        {
          return t('опыта');
        }
      case COMPETITION_METRIC.DAMAGE:
        {
          return t('урона');
        }
      case COMPETITION_METRIC.RIBBONS:
        {
          return t('лент');
        }
      default:
        {
          return t('опыта');
        }

    }
  };

  render() {
    const total = this.props.totalValue > this.props.maxValue ? this.props.maxValue : this.props.totalValue;
    const hideTitle = this.props.hideTitle === true;
    return <div className={styles.wrapper}>
                {hideTitle ? null : <Fragment>
                        <span className={styles.title}>{this.props.title}</span>
                        <span className={styles.target}>{this.props.target}</span>
                        {this.props.subTitle ? <span className={styles.subTitle}>{this.props.subTitle}</span> : null}
                    </Fragment>}
                <div className={styles.lineWrapper}>
                    <div className={styles.topSignWrapper}>
                        <span className={styles.topSign}>{this.props.mPoints}</span>
                        <div className={styles.rightSign}>
                            <span className={styles.topSignTotal}>{`${thousands(total)}`}</span>
                            <span className={styles.topSign}>{`/${thousands(this.props.maxValue)}`}</span>
                        </div>
                    </div>
                    <div className={styles.progressLine}>
                        <DivTooltip style={{
            width: `${this.getProgressPercent(this.props.totalValue, this.props.maxValue)}%`
          }} className={styles.totalProgress} tooltipBody={<TooltipBody>
                                    <Interpolate className={styles.rewardDescriptionRow} i18nKey={x('Прогресс задачи:  %(totalValue)s')} totalValue={thousands(this.props.totalValue)} parent={'span'} t={t} />
                                    {this.props.myValue ? <Interpolate className={styles.rewardDescriptionRow} i18nKey={x('Ваш вклад: %(myValue)s')} myValue={thousands(this.props.myValue)} parent={'span'} t={t} /> : null}
                                </TooltipBody>}>
                            <div className={styles.lineInnerContent}>
                                {this.props.myValue ? <div className={styles.myProgressLine} style={{
                width: `${this.getProgressPercent(this.props.myValue, this.props.totalValue)}%`
              }} /> : null}
                            </div>
                        </DivTooltip>
                        {(this.props.breakpoints && this.props.breakpoints.length > 0) ? this.props.breakpoints.map((item, index) => {
            const rightOffsetPercent = 100 - this.getProgressPercent(item.value, this.props.maxValue);
            const isReachedGrade = item.value <= this.props.totalValue;


            return <div key={`Separator_${index}`} className={`${styles.separator} ${isReachedGrade ? styles.separatorReached : ''}`} style={{ right: `${rightOffsetPercent}%` }} />;
          }) : null}
                    </div>
                    {(this.props.breakpoints && this.props.breakpoints.length > 0) ? <div className={styles.breakpointsWrapper}>
                                    {this.props.breakpoints.map((item, index) => {
            const rightOffsetPercent = 100 - this.getProgressPercent(item.value, this.props.maxValue);
            const isReachedGrade = item.value <= this.props.totalValue;
            return <DivTooltip key={`BreakPoint_${index}`} className={`${styles.breakpoint} ${isReachedGrade ? styles.breakpointReached : ''}`} style={{ right: `${rightOffsetPercent}%` }} tooltipBody={<Fragment>
                                                        <TooltipBody>
                                                            <Interpolate className={styles.rewardDescriptionRow} i18nKey={x('Этап %(stage)s: %(score)s %(metric)s')} score={thousands(item.value)} stage={index + 1} parent={'span'} metric={this.getMetric()} t={t} />
                                                            <Interpolate className={styles.rewardDescriptionRow} i18nKey={x('Награда за этап: %(reward)s')} reward={<Currency amount={item.reward.amount} type={'oil'} isBold={false} t={t} />} parent={'span'} t={t} />
                                                        </TooltipBody>
                                                    </Fragment>}>
                                                <div className={`${styles.breakpointIcon} ${styles[`breakpointIcon-${item.reward.type}`]}`} />
                                                <div className={styles.breakpointValue}>{`${item.reward.amount}`}</div>
                                            </DivTooltip>;
          })}
                                </div> : null}
                </div>
                <div className={styles.personalStats}>
                    <Interpolate i18nKey={x('Ваш личный вклад %(personalProgress)s/%(maxPersonalProgress)s')} personalProgress={<span className={styles.personalStatsValue}>{thousands(this.props.myValue)}</span>} maxPersonalProgress={thousands(this.props.myValueMax)} />
                </div>
            </div>;
  }
}

export default ProgressBar;